<div class="erkmo_Main_section register_main_section">
    <div class="sign_up_body">
        <div class="register_main_inner h-100">
            <div class="register_main_box">
                <h1 class="sign_up_heading">Email Verification</h1>
                 <div>{{message}}</div>
                 <div *ngIf="verified">
                    <div>Redirecting you to payment page in {{time}}...</div>
                 </div>
            </div>
        </div>
    </div>
    <div class="erkmo_footer"></div>
</div>